import React from "react";
import { submitMedikreditClaim } from "../../mediKreditapi";

function formatDateYYYYMMDD(dateStr) {
  if (!dateStr) return "";
  return dateStr.replace(/-/g, "");
}

export async function ReverseClaim({ practice, account, selectedPatient, invoice, claimtxn }) {
  const practitioner = {
    hpcsa: invoice.practitioner.hpcsa,
  };

  const practiceInfo = {
    sp_bhf: practice.practiceNumber, //"0387495",
    sp_hpc: invoice.practitioner.hpcsa,
    grp_prac: practice.practiceNumber, //"0387495",
    tx_nbr: claimtxn,
    msg_fmt: "16",
    tx_cd: "11"
  };

  const medicalAidInfo = {
    plan: account.accountMediKreditPlanNumber03, // fallback or use account.accountMedicalAidPlanCode
    ch_id: account.accountMedicalAidNumber,
    sname: account.accountLastName,
    inits: account.accountInitials,
  };

  const patientInfo = {
    dep_cd: selectedPatient.patientMedicalAidDependantCode,
    dob: formatDateYYYYMMDD(selectedPatient.patientDOB),
    id_nbr: selectedPatient.patientIdNumber,
    fname: selectedPatient.patientFirstName,
    gend: selectedPatient.patientGender,
    rlnship: selectedPatient.patientRelationship,
    status: invoice.outPatient,
    int: selectedPatient.patientInitials
  };

  const financialInfo = {
    totalMedAidAmount: invoice.totalMedicalAidAmount,
  }

  const caseInfo = {
    caseBHF: invoice.inPatientCase?.caseBHF,
    caseHPCSA: invoice.inPatientCase?.caseHPCSA,
    caseICD10: invoice.inPatientCase?.caseICD10,
  };

  // Build transaction info with modifier logic
  let currentLineNumber = 1;
  const transactionInfo = [];

  invoice.lines
    .filter((line) => line.privatePayment !== true)
    .forEach((line) => {
      // Base line
      const baseLine = {
        lin_num: currentLineNumber++,
        pay_adv: "P",
        tp: line.tariffCode ? "2" : "",
        cdg_set: "2",
        auth_nbr: "",
        descr: line.description,
        process_tp: "01",
        tar_cd: line.tariffCode,
        qty: "1",
        units: line.quantity,
        unit_tp: "06",
        st_dt: formatDateYYYYMMDD(line.appointmentDateSet || line.appointmentDateCustom),
        st_tm: "111213",
        end_dt: formatDateYYYYMMDD(line.appointmentDateSet || line.appointmentDateCustom),
        end_tm: "121213",
        stg_ind1: "01",
        cd1: line.icd101,
        stg_ind2: "02",
        cd2: line.icd102,
        tp_ind: "01",
        bhf_nbr: practice.practiceNumber,
        hpc_nbr: invoice.practitioner.hpcsa,
        tar_ind: "03",
        price: line.rate,
        bs_of_cst: "03",
        gross: line.rate,
        sp_hpc: invoice.practitioner.hpcsa,
      };

      transactionInfo.push(baseLine);

      // Handle modifiers - support both array and single modifier for backward compatibility
      let modifiers = [];
      if (line.modifier) {
        if (Array.isArray(line.modifier)) {
          modifiers = line.modifier.filter(Boolean); // Remove any null/undefined values
        } else {
          modifiers = [line.modifier]; // Convert single modifier to array
        }
      }

      // Create a separate modifier line for each modifier
      modifiers.forEach((modifier) => {
        const modifiedLine = {
          lin_num: currentLineNumber++,
          pay_adv: "P",
          tp: "3", // Set to "3" for modifier lines
          cdg_set: "2",
          auth_nbr: "",
          descr: line.description,
          process_tp: "01",
          tar_cd: line.tariffCode,
          qty: "1",
          units: line.quantity,
          unit_tp: "06",
          st_dt: formatDateYYYYMMDD(line.appointmentDateSet || line.appointmentDateCustom),
          st_tm: "111213",
          end_dt: formatDateYYYYMMDD(line.appointmentDateSet || line.appointmentDateCustom),
          end_tm: "121213",
          stg_ind1: "01",
          cd1: line.icd101,
          stg_ind2: "02",
          cd2: line.icd102,
          tp_ind: "01",
          bhf_nbr: practice.practiceNumber,
          hpc_nbr: invoice.practitioner.hpcsa,
          tar_ind: "03",
          price: "0", // Set to "0" for modifier lines
          bs_of_cst: "03",
          gross: "0", // Set to "0" for modifier lines
          modtp: "3",
          mod: modifier,
          sp_hpc: invoice.practitioner.hpcsa,
        };

        transactionInfo.push(modifiedLine);
      });
    });

  console.log("transactionInfo", transactionInfo);
  try {
    const response = await submitMedikreditClaim(
      practiceInfo,
      medicalAidInfo,
      patientInfo,
      transactionInfo,
      financialInfo,
      caseInfo
    );
    
    console.log("✅ Claim Response:", response);
    return response;
  } catch (error) {
    console.error("❌ Claim Submission Failed:", error);
    throw error;
  }
}